module.exports = __webpack_public_path__ + "static/media/mario-eyebrows.d00f74b7.svg";